var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.026,1.501L10,1.5L9.974,1.501L9.949,1.503L9.924,1.506L9.899,1.51L9.875,1.516L9.851,1.523L9.828,1.53L9.82,1.534L9.797,1.543L9.781,1.55L9.775,1.553L9.76,1.562L9.738,1.574L9.718,1.587L9.698,1.602L9.678,1.617L9.671,1.624L5.542,5.237C5.334,5.418 5.313,5.735 5.495,5.942C5.676,6.15 5.992,6.171 6.2,5.989L9.5,3.102L9.5,13.871C9.5,14.147 9.724,14.371 10,14.371C10.276,14.371 10.5,14.147 10.5,13.871L10.5,3.102L13.8,5.989C14.007,6.171 14.324,6.15 14.505,5.942C14.687,5.735 14.666,5.418 14.458,5.237L10.329,1.624L10.322,1.617L10.302,1.602L10.282,1.587L10.261,1.574L10.247,1.565L10.24,1.562L10.225,1.553L10.202,1.543L10.18,1.534L10.172,1.53L10.157,1.525L10.149,1.523L10.125,1.516L10.101,1.51L10.076,1.506L10.051,1.503L10.026,1.501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.242,9.742L1.242,16C1.242,17.381 2.361,18.5 3.742,18.5L16.258,18.5C17.639,18.5 18.758,17.381 18.758,16L18.758,9.742C18.758,9.466 18.534,9.242 18.258,9.242C17.982,9.242 17.758,9.466 17.758,9.742L17.758,16C17.758,16.828 17.086,17.5 16.258,17.5C16.258,17.5 3.742,17.5 3.742,17.5C2.914,17.5 2.242,16.828 2.242,16L2.242,9.742C2.242,9.466 2.018,9.242 1.742,9.242C1.466,9.242 1.242,9.466 1.242,9.742Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.85760a3b2f6b4ed976b6af9f4deaae50.svg";
export { ForwardRef as ReactComponent };